import { useState, useEffect } from 'react'

const useLayoutState = () => {
  const [selectedSavedCard, setSelectedSavedCard] = useState({})
  const [
    isAcceptedTermsAndConditions,
    setIsAcceptedTermsAndConditions,
  ] = useState(true)
  const [isVisibleSectionAddNewCard, setIsVisibleSectionAddNewCard] = useState(
    false,
  )
  const [
    isVisibleAddNewPaymentMethod,
    setIsVisibleAddNewPaymentMethod,
  ] = useState(false)
  const [iIsVisibleAddNewAccountBi, setIsVisibleAddNewAccountBi] = useState(
    false,
  )
  const [selectAccountBi, setSelectAccountBi] = useState(null)
  const [requestId, setRequestId] = useState(null)
  const [urlAccountBi, setUrlAccountBi] = useState('')
  const [urltiendaApps, setUrltiendaApps] = useState('')
  const [saveCard, setSaveCard] = useState(false)
  const [year, setYear] = useState('')
  const [month, setMonth] = useState('')
  const [saveNewCard, setSaveNewCard] = useState(true)
  const [yearNewCard, setYearNewCard] = useState('')
  const [monthNewCard, setMonthNewCard] = useState('')
  const [cvv, setCvv] = useState('')
  const [numberCard, setNumberCard] = useState('')
  const [maxLengthCvv, setMaxLengthCvv] = useState(3)
  const [maxLengthNumberCard, setMaxLengthNumberCard] = useState(16)
  const [processingPayment, setProcessingPayment] = useState(false)
  const [responseService, setResponseService] = useState(null)
  const [responseServiceBilling, setResponseServiceBilling] = useState(null)
  const [processingBilling, setProcessingBilling] = useState(false)
  const [isEnabledPayWithSavedCard, setIsEnabledPayWithSavedCard] = useState(
    false,
  )
  const [isEnabledPayWithNewCard, setIsEnabledPayWithNewCard] = useState(false)

  const [currentCategoryMetrics, setCurrentCategoryMetrics] = useState(
    'Recarga-',
  )

  const [canClickButton, setCanClickButton] = useState(true)

  const [menuVisible, setMenuVisible] = useState(false)
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(null)

  const [codeBilling, setCodeBilling] = useState(null)

  const [isBiPayment, setIsBiPayment] = useState(null)
  const [isBiPaymentVisible, setIsBiPaymentVisible] = useState(true)
  const [isBiNewPayment, setIsBiNewPayment] = useState(null)

  const isValidatedFieldsToPayWithSavedCard = () =>
    year !== '' &&
    Number(year) > 0 &&
    year.length === 2 &&
    month !== '' &&
    Number(month) > 0 &&
    isAcceptedTermsAndConditions === true

  const isValidatedFieldsToPayWithNewCard = () =>
    yearNewCard !== '' &&
    Number(yearNewCard) > 0 &&
    yearNewCard.length === 2 &&
    monthNewCard !== '' &&
    Number(monthNewCard) > 0 &&
    cvv !== '' &&
    Number(cvv) > 0 &&
    cvv.length === maxLengthCvv &&
    numberCard !== '' &&
    Number(numberCard) > 0 &&
    numberCard.length === maxLengthNumberCard &&
    isAcceptedTermsAndConditions === true

  useEffect(() => {
    setIsEnabledPayWithSavedCard(isValidatedFieldsToPayWithSavedCard())
  }, [year, month, isAcceptedTermsAndConditions])

  useEffect(() => {
    setIsEnabledPayWithNewCard(isValidatedFieldsToPayWithNewCard())
  }, [yearNewCard, monthNewCard, cvv, numberCard, isAcceptedTermsAndConditions])

  const clearData = () => {
    setSaveCard(false)
    setYear('')
    setMonth('')
    setSaveNewCard(true)
    setYearNewCard('')
    setMonthNewCard('')
    setCvv('')
    setNumberCard('')
    setSelectedSavedCard({})
    setIsVisibleSectionAddNewCard(false)
    setIsVisibleAddNewPaymentMethod(false)
    setIsVisibleAddNewAccountBi(false)
    setSelectAccountBi(null)
    setRequestId(null)
  }

  const formatNumber = value => {
    if (typeof value === 'number') {
      if (Number.isInteger(value)) {
        return value.toString()
      } else {
        return value.toFixed(2)
      }
    }
    return ''
  }

  return {
    setSelectedSavedCard,
    selectedSavedCard,
    setIsAcceptedTermsAndConditions,
    isAcceptedTermsAndConditions,
    isVisibleSectionAddNewCard,
    setIsVisibleAddNewPaymentMethod,
    setIsVisibleSectionAddNewCard,
    isVisibleAddNewPaymentMethod,
    iIsVisibleAddNewAccountBi,
    setIsVisibleAddNewAccountBi,
    setSelectAccountBi,
    selectAccountBi,
    setRequestId,
    requestId,
    urlAccountBi,
    setUrlAccountBi,
    urltiendaApps,
    setUrltiendaApps,
    setSaveCard,
    saveCard,
    year,
    setYear,
    setMonth,
    month,
    saveNewCard,
    setSaveNewCard,
    yearNewCard,
    setYearNewCard,
    monthNewCard,
    setMonthNewCard,
    cvv,
    numberCard,
    setCvv,
    setNumberCard,
    setMaxLengthCvv,
    maxLengthCvv,
    maxLengthNumberCard,
    setMaxLengthNumberCard,
    setProcessingPayment,
    processingPayment,
    responseService,
    setResponseService,
    responseServiceBilling,
    setResponseServiceBilling,
    processingBilling,
    setProcessingBilling,
    isEnabledPayWithNewCard,
    isEnabledPayWithSavedCard,
    clearData,
    isValidatedFieldsToPayWithNewCard,
    isValidatedFieldsToPayWithSavedCard,
    setCurrentCategoryMetrics,
    currentCategoryMetrics,
    canClickButton,
    menuVisible,
    setCanClickButton,
    setMenuVisible,
    opcionSeleccionada,
    setOpcionSeleccionada,
    setCodeBilling,
    codeBilling,
    formatNumber,
    isBiPayment,
    setIsBiPayment,
    isBiPaymentVisible,
    setIsBiPaymentVisible,
    isBiNewPayment,
    setIsBiNewPayment,
  }
}

export default useLayoutState
